import React, { Component } from 'react';
import classNames from 'classnames';
import PostCreateDateViewer from '../../../../library/board/components/PostCreateDateViewer';
import PostNewIcon from '../../../common/components/board/PostNewIcon';
import SlideUpDownAni from '../../../common/components/SlideUpDownAni';
import NoSsrWrapper from '../../../../wrapper/NoSsrWrapper';
import HtmlViewer from '../../../common/components/board/HtmlViewer';

class NoticeListItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isReady: true,
      height: undefined,
    };

    this.openPostIdChange = this.openPostIdChange.bind(this);
    this.contentLoaded = this.contentLoaded.bind(this);
  }

  contentLoaded(id, height) {
    this.setState({
      isReady: false,
      height: height,
    });
  }

  openPostIdChange(e) {
    e.preventDefault();
    if (this.props.targetPostInfo.id !== this.props.openPostId) {
      this.props.changeOpenPostId(this.props.targetPostInfo.id);
      this.props.getPostInfo(this.props.targetPostInfo.id);
    } else {
      this.props.changeOpenPostId(0);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.openPostId === this.props.targetPostInfo.id &&
      this.props.openPostId !== this.props.targetPostInfo.id
    ) {
      this.props.initPostDetail();
    }
  }

  render() {
    const { targetPostInfo, postInfo } = this.props;
    let title = this.props.targetPostInfo
      ? this.props.targetPostInfo.title
      : '';
    const isDown = this.props.targetPostInfo.id === this.props.openPostId;
    return (
      <li className={classNames({ on: isDown })}>
        <a href="#" className="title" onClick={this.openPostIdChange}>
          {targetPostInfo.is_noticed === true && (
            <em className="tag notice">공지</em>
          )}
          {title}
          <PostNewIcon postInfo={targetPostInfo} />
          <span className="date">
            <PostCreateDateViewer
              postInfo={targetPostInfo}
              dateFormat="YYYY-MM-DD"
            />
          </span>
        </a>
        <NoSsrWrapper>
          <SlideUpDownAni isDown={isDown}>
            {isDown && (
              <div className="ans">
                <figure>
                  <HtmlViewer html={postInfo.html ?? ''} />
                </figure>
              </div>
            )}
          </SlideUpDownAni>
        </NoSsrWrapper>
      </li>
    );
  }
}

export default NoticeListItem;
